// extracted by mini-css-extract-plugin
export default {"base":"base-tHm1L"};